import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { api } from "../lib/api";
import { Clock, Users, Bus, ArrowRight } from "lucide-react";

export default function RoutesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/routes").then(r=>setItems(r.data)).catch(()=>{}); }, []);
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 pt-10 pb-16">
        <div className="text-xs uppercase tracking-widest text-[#ea580c] font-semibold">Daily Routes</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tight">Fixed departures. Book a seat.</h1>
        <p className="text-slate-600 mt-4 max-w-2xl">Every seat can be reserved online. Pay online or at pickup.</p>
        {items.length === 0 && (
          <div className="mt-10 p-10 rounded-2xl bg-white border-2 border-dashed border-slate-300 text-center" data-testid="routes-page-empty">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#ea580c]/10 text-[#ea580c] text-[10px] uppercase tracking-widest font-bold">Coming Soon</div>
            <h3 className="mt-3 text-2xl font-display font-black text-[#1e1b4b]">Next Ride / Yatra will be shown here</h3>
            <p className="mt-2 text-slate-600 text-sm max-w-lg mx-auto">Scheduled daily routes will appear on this page as soon as they're published. In the meantime, request a custom trip or book a private vehicle.</p>
            <div className="mt-5 flex flex-wrap justify-center gap-2">
              <Link to="/custom-booking" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#ea580c] hover:bg-orange-700 text-white font-bold text-xs" data-testid="routes-empty-custom">Plan a Custom Trip <ArrowRight className="w-3.5 h-3.5" /></Link>
              <Link to="/book" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#1e1b4b] text-white font-bold text-xs" data-testid="routes-empty-book">Book Vehicle</Link>
            </div>
          </div>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
          {items.map(r => (
            <div key={r.id} className="p-6 rounded-2xl bg-white border border-slate-200 hover:border-[#ea580c] transition-colors" data-testid={`route-list-${r.id}`}>
              <div className="flex items-center justify-between">
                <div className="font-display font-bold text-xl text-[#1e1b4b]">{r.from_place} → {r.to_place}</div>
                <div className="text-xs px-2 py-1 rounded-full bg-slate-100 font-medium">{r.ac ? "AC" : "Non-AC"}</div>
              </div>
              <div className="text-sm text-slate-500 mt-1">{r.name}</div>
              <div className="mt-4 flex flex-wrap items-center gap-3 text-sm">
                <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-[#ea580c]" /> Dep {r.departure_time}</span>
                <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5 text-[#ea580c]" /> {r.seat_capacity} seats</span>
                <span className="inline-flex items-center gap-1"><Bus className="w-3.5 h-3.5 text-[#ea580c]" /> {r.vehicle_type}</span>
              </div>
              {r.stops?.length > 0 && <div className="mt-2 text-xs text-slate-500">Via: {r.stops.join(" · ")}</div>}
              <div className="mt-5 flex items-end justify-between">
                <div><div className="text-2xl font-black text-[#1e1b4b]">₹{r.price_per_seat}<span className="text-xs font-normal text-slate-500">/seat</span></div></div>
                <Link to={`/book?from_place=${encodeURIComponent(r.from_place)}&to_place=${encodeURIComponent(r.to_place)}&travel_date=${new Date().toISOString().slice(0,10)}&passengers=1`} className="text-sm font-semibold text-[#ea580c] hover:underline inline-flex items-center gap-1">Book <ArrowRight className="w-3.5 h-3.5" /></Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
